import type { QualificationChecklist } from '../../api/types';

/**
 * Completion percent of a checklist: items with a decided result (pass or n/a)
 * over all items. Fail and pending both count as "not done" — a failed item
 * still needs rework before the checklist is complete.
 */
export function qualificationPct(q: QualificationChecklist): number {
  const items = q.items ?? [];
  if (items.length === 0) return 0;
  const done = items.filter((i) => i.result === 'pass' || i.result === 'na').length;
  return Math.round((done / items.length) * 100);
}
